import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Button, Form,
  Input, Upload, Select,
  Card
} from "antd";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { Post } from "../../config/api/post";
import { CAR, UPLOADS_URL } from "../../config/constants/api";
import DashbordSidebar from "../../components/DashboardSidebar";
import { PlusOutlined } from "@ant-design/icons";

import swal from "sweetalert";

const normFile = (e) => {
  if (Array.isArray(e)) {
    console.log(e);
    return e;
  }
  return e?.fileList;
};

function CreateAccount() {
  const [form] = Form.useForm();
  // const { TextArea } = Input;
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [gallery, setGallery] = useState([]);
  // const [imageUrl, setImageUrl] = useState("");
  // const [imageObject, setImageObject] = useState(null);
  const location = useLocation();
  const [oldImages, setOldImages] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [existingImages, setExistingImages] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const vehicleDetails = location?.state?.vehicleDetails;
  const [initialVehicleDetails, setInitialVehicleDetails] = useState(null);
  const token = useSelector((state) => state.user.userToken);

  // const handleChange2 = () => {
  //   swal("", "Congrats! You have been registered successfully", "success");
  // };
  useEffect(() => {
    if (!vehicleDetails) {
      navigate(-1);
    } else {
      setInitialVehicleDetails(vehicleDetails);
      form.setFieldsValue({
        serviceType: vehicleDetails?.serviceType,
        brand: vehicleDetails?.brand,
        model: vehicleDetails?.model,
        name: vehicleDetails?.name,
        carNumber: vehicleDetails?.carNumber,
        passengerCapacity: vehicleDetails?.passengerCapacity,
      });
      const combinedImages = [
        ...(vehicleDetails?.image ? [UPLOADS_URL + vehicleDetails.image] : []),
        ...(vehicleDetails?.gallery || []).map(
          (filename) => UPLOADS_URL + filename
        ),
      ];

      setFileList(
        combinedImages.map((url) => ({ uid: url, name: url, url: url }))
      );
      setExistingImages(
        combinedImages.map((url) => ({ uid: url, name: url, url: url }))
      );
    }
    // eslint-disable-next-line
  }, []);
  // const handleChange = (value) => {
  //   console.log(`selected ${value}`);
  // };

  // const { Search } = Input;
  // const user = useSelector((state) => state.user.userData);
  // // const token = useSelector((state) => state.user.userToken);
  const [loading, setLoading] = React.useState(false);
  console.log(loading, "loading");
  const onFinish = (values) => {
    const formValuesChanged = () => {
      if (!initialVehicleDetails) {
        return true;
      }
      return (
        values.serviceType !== initialVehicleDetails?.serviceType ||
        values.brand !== initialVehicleDetails?.brand ||
        values.model !== initialVehicleDetails?.model ||
        values.name !== initialVehicleDetails?.name ||
        values.carNumber !== initialVehicleDetails?.carNumber ||
        values.passengerCapacity !== initialVehicleDetails?.passengerCapacity ||
        oldImages.length > 0 ||
        newImages.length > 0
      );
    };
    if (formValuesChanged()) {
      let data = new FormData();
      if (newImages.length > 0) {
        const galleryToAppend = newImages.map((file, index) => {
          return file.originFileObj;
        });
        galleryToAppend.forEach((val) => {
          data.append("gallery", val);
        });
      }
      if (oldImages.length > 0) {
        const oldImagesToAppend = oldImages.map((file, index) => {
          const parts = file.url.split("/");
          const filename = parts[parts.length - 1];
          return filename;
        });
        oldImagesToAppend.forEach((val, index) => {
          data.append(`oldImages[${index}]`, val);
        });
      }
      if (fileList[0]?.originFileObj) {
        data.append("image", fileList[0]?.originFileObj);
      }
      if (vehicleDetails?.serviceType !== values?.serviceType) {
        data.append("serviceType", values.serviceType);
      }
      if (vehicleDetails?.brand !== values?.brand) {
        data.append("brand", values.brand);
      }
      if (vehicleDetails?.model !== values?.model) {
        data.append("model", values.model);
      }
      if (vehicleDetails?.name !== values?.name) {
        data.append("name", values.name);
      }
      if (vehicleDetails?.carNumber !== values?.carNumber) {
        data.append("carNumber", values.carNumber);
      }
      if (vehicleDetails?.passengerCapacity !== values?.passengerCapacity) {
        data.append("passengerCapacity", values.passengerCapacity);
      }
      Post(CAR.updateCarRequest, data, token, null, "multipart")
        .then((response) => {
          if (response?.status) {
            swal("System Alert", response?.message, "success");
            navigate("/vehicleView");
          }
        })
        .catch((err) => {
          console.log(err, "err");
          const message = err?.response?.data?.message;
          if (message) {
            swal("Oops", message, "error");
          }
        });
    } else {
      swal("System Alert!", "No changes detected", "error");
      return;
    }
    setLoading(true);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const multipleChange = ({ fileList: newFileList }) => {
    const existingImageUIDs = existingImages.map((image) => image.uid);
    const newImageUIDs = newFileList.map((file) => file.uid);
    const removedImages = existingImages.filter(
      (image) => !newImageUIDs.includes(image.uid)
    );
    setOldImages([...removedImages]);
    const updatedFileList = newFileList.filter(
      (file) => !existingImageUIDs.includes(file.uid)
    );
    setNewImages(updatedFileList);
    setFileList(newFileList);
  };
  return (
    <div className="shop-page">
      <Row style={{ width: "100%", justifyContent: "center" }}>
        <Col xs={23} md={21}>
          <div className="shop-page-main">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={24} lg={24} xl={24}>
                <div className="my-account-profile">
                  <section className="side-menu-parent">
                    <DashbordSidebar />
                    <div className="about-us-section">
                      <div className="bg-paren">
                        <Row justify="center">
                          <Col xl={24} lg={24} md={22} xs={23}>
                            <Card
                              className="orderDetails"
                              style={{ padding: "10px 0" }}
                            >
                              <Row gutter={30} style={{ marginBottom: "50px" }}>
                                <Col lg={24} md={24} xs={24}>
                                  <div
                                    className="auth-box"
                                    style={{ height: "auto" }}
                                  >
                                    <div className="blur-bg-inner-card-form">
                                      <h2 className="auth-heading">
                                        Edit Car Details
                                      </h2>
                                      <Form
                                        className="row g-3"
                                        name="basic"
                                        layout="vertical"
                                        initialValues={{
                                          remember: true,
                                        }}
                                        onFinish={onFinish}
                                        onFinishFailed={onFinishFailed}
                                        autoComplete="off"
                                        form={form}
                                      >
                                        <Row
                                          className="row-res-margin-0"
                                          style={{
                                            width: "100%",
                                            justifyContent: "center",
                                            textAlign: "center",
                                          }}
                                          gutter={[16, 16]}
                                        >
                                          <Col lg={16} md={20} xs={24}>
                                            <p
                                              className="web-p"
                                              style={{
                                                color: "#616161",
                                                paddingTop: "5px",
                                              }}
                                            >
                                              Please register your vehicle. You
                                              will be able to view your
                                              registered vehicle details here.
                                            </p>
                                          </Col>
                                        </Row>
                                        <Row
                                          style={{
                                            width: "100%",
                                            justifyContent: "center",
                                          }}
                                          gutter={[16, 16]}
                                          className="row-res-margin-0"
                                        >
                                          <Col lg={12} md={12} xs={24}>
                                            <Form.Item
                                              label="Vehicle Type"
                                              name="serviceType"
                                            >
                                              <Select placeholder="Select">
                                                <Select.Option value="Black">
                                                  Black Luxury
                                                </Select.Option>
                                                <Select.Option value="Ultra">
                                                  Ultra Luxury
                                                </Select.Option>
                                                <Select.Option value="Ultra Beyond">
                                                  Ultra Beyond Luxury
                                                </Select.Option>
                                                <Select.Option value="Suv">
                                                  SUV Luxury
                                                </Select.Option>
                                              </Select>
                                            </Form.Item>
                                          </Col>
                                          <Col lg={12} md={12} xs={24}>
                                            <Form.Item
                                              label="Brand Name"
                                              name="brand"
                                            >
                                              <Input
                                                size="large"
                                                placeholder="Enter Brand Name"
                                                className="web-input"
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col lg={12} md={12} xs={24}>
                                            <Form.Item
                                              label="Car Name"
                                              name="name"
                                            >
                                              <Input
                                                size="large"
                                                placeholder="Enter Car Name"
                                                className="web-input"
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col lg={12} md={12} xs={24}>
                                            <Form.Item
                                              label="Car Model"
                                              name="model"
                                            >
                                              <Input
                                                size="large"
                                                placeholder="Enter Model"
                                                className="web-input"
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col lg={12} md={12} xs={24}>
                                            <Form.Item
                                              label="Car Number"
                                              name="carNumber"
                                            >
                                              <Input
                                                size="large"
                                                placeholder="Enter Car Number of your vehicle"
                                                className="web-input"
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col lg={12} md={12} xs={24}>
                                            <Form.Item
                                              label="Passenger Capacity"
                                              name="passengerCapacity"
                                            >
                                              <Input
                                                size="large"
                                                placeholder="Enter Passenger Capacity"
                                                className="web-input"
                                              />
                                            </Form.Item>
                                          </Col>

                                          <Col lg={24} md={24} xs={24}>
                                            <p
                                              style={{
                                                margin: "10px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Upload Car Images*
                                            </p>
                                            <Form.Item
                                              valuePropName="fileList"
                                              getValueFromEvent={normFile}
                                            >
                                              <Upload
                                                action="/upload.do"
                                                listType="picture-card"
                                                onChange={multipleChange}
                                                fileList={fileList}
                                              >
                                                <button
                                                  style={{
                                                    border: 0,
                                                    background: "none",
                                                  }}
                                                  type="button"
                                                >
                                                  <PlusOutlined />
                                                  <div
                                                    style={{
                                                      marginTop: 8,
                                                    }}
                                                  >
                                                    Upload Car Images
                                                  </div>
                                                </button>
                                              </Upload>
                                              <p className="web-p">
                                                (Recommended PNG, JPG upto 5MB)
                                              </p>
                                            </Form.Item>
                                          </Col>
                                          <div
                                            className=""
                                            style={{
                                              textAlign: "center",
                                              margin: "2px 5px",
                                              display: "flex",
                                              gap: "12px",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <Button
                                              type=""
                                              htmlType="submit"
                                              className="btn web-btn px-5"
                                            >
                                              Save
                                            </Button>
                                            <Button
                                              type="default"
                                              className="btn web-btn px-5"
                                              onClick={() => navigate("/vehicleView")}
                                            >
                                              Cancel
                                            </Button>
                                          </div>
                                        </Row>
                                      </Form>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </section>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default CreateAccount;
